export default function getPreviewRoutePrefix(path: string) {
  return `/:previewMode/:tenantDomain${path}`;
}
